import { Component, EventEmitter, Input, Output } from "@angular/core";
import { POEmailContact } from "../../../../core/models/orders/poEmailContact";
import { TableModule } from "primeng/table";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

@Component({
  selector: "jni-po-email-recipients",
  templateUrl: "./po-email-recipients.component.html",
  styleUrls: ["./po-email-recipients.component.scss"],
  imports: [TableModule, FormsModule, CommonModule],
})
export class PoEmailRecipientsComponent {
  @Input() recipientsList: POEmailContact[] = [];
  @Output() recipientsDeletedEvent = new EventEmitter<POEmailContact[]>();
  @Output() recipientsAddEvent = new EventEmitter();
  recipientsListSelected!: POEmailContact[];

  onDelete() {
    const recipientArray = [] as POEmailContact[];
    recipientArray.push(
      this.recipientsListSelected as unknown as POEmailContact
    );
    this.recipientsDeletedEvent.emit(recipientArray);
    this.recipientsListSelected = [];
  }

  onAdd() {
    this.recipientsAddEvent.emit();
    this.recipientsListSelected = [];
  }
}
